import { configureStore } from '@reduxjs/toolkit'
import datasetReducer from './routes/NewMap/reduxStates/dataset.ts'
import layersReducer from './routes/NewMap/reduxStates/layers.ts'
import localDataReducer from './routes/NewMap/reduxStates/localData.ts'
// import revSourcesReducer from './routes/Prism/RevUtils/storeRevSources'

export const store = configureStore({
  reducer: {
    layers: layersReducer,
    dataset: datasetReducer,
    localData: localDataReducer,
    // revSources: revSourcesReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
